import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RoleService } from '../../services/role.service';
import { MultiCrudDataSource } from '../../table-datasouces/multi-crud.datasource';
import { VoucherOrder } from '../../dto/voucher-order';
import { VoucherOrdersService } from '../services/voucherOrders.service';
import { toDateString, toDateTimeString } from '../../providers/app-date-adapter';
import { AppMatCustomAction } from '../../shared/mat-table-generator/mat-table-core/app-mat-custom-action';
import { MatTableGeneratorComponent } from '../../shared/mat-table-generator/mat-table-generator.component';
import { MatDialog } from '@angular/material/dialog';
import { VoucherOrderStatus } from './../../models/enums/voucher-order-status';
import { ConfirmDialogComponent } from '../../shared/confirm-dialog/confirm-dialog.component';
import { InvoicesService } from '../services/invoices.service';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-vouchers',
  templateUrl: './voucher-orders.component.html',
  styleUrls: ['./voucher-orders.component.css']
})
export class VoucherOrderComponent implements OnInit {
  @ViewChild(MatTableGeneratorComponent, { static: true }) table: MatTableGeneratorComponent;

  voucherOrdersCustomActions: any[] = [];
  constructor(
    private route: ActivatedRoute,
    private roleService: RoleService,
    private voucherOrdersService: VoucherOrdersService,
    private changeDetectorRefs: ChangeDetectorRef,
    private snackBar: MatSnackBar,
    public dialog: MatDialog,
    private invoicesService: InvoicesService

  ) { }

  dataSource = new MultiCrudDataSource(this.voucherOrdersService);
  columns = [
    { columnDef: 'id', header: 'Id', cell: (row: VoucherOrder) => `${row.id}` },
    { columnDef: 'packageName', header: 'Package', cell: (row: VoucherOrder) => `${row.packageName || ''}`, sortable: false  },
    { columnDef: 'productName', header: 'Product Name', cell: (row: VoucherOrder) => `${row.product.name}`, sortable: false  },
    { columnDef: 'companyName', header: 'Company', cell: (row: VoucherOrder) => `${row.product.company.name}` , sortable: false},
    { columnDef: 'voucherOrderStatusName', header: 'Status', cell: (row: VoucherOrder) => `${row.voucherOrderStatusName}`, sortable: false },
    { columnDef: 'generatedDate', header: 'Voucher Date', cell: (row: VoucherOrder) => `${toDateTimeString(row.generatedDate)}` },
    { columnDef: 'expireDate', header: 'Expiry Date', cell: (row: VoucherOrder) => `${toDateString(row.expireDate)}` },
  ];

  ngOnInit() {
    if ( this.roleService.hasRoles( 'admin' ) ) {
      this.voucherOrdersCustomActions = [
        new AppMatCustomAction( 'euro_symbol', 'Mark Selected items as Paid', true, ( rows: VoucherOrder[] ) => {
          const dialogRef = this.dialog.open(ConfirmDialogComponent, {
                  data: {
                    title: 'Mark as paid',
                    text: 'Are you sure want to mark these voucher orders as paid?'
                  },
                  minWidth: 350,
                });
                dialogRef.afterClosed().subscribe(result => {
                  if (result == 'ok') {
                    this.voucherOrdersService.changeStatus(rows.map(row => row.id), VoucherOrderStatus.Active).subscribe(
                      () => {
 this.invoicesService.markAsPaidMany(rows.map(row => row.invoiceId)).subscribe(
                        () => {
this.refreshDataSource(); this.showMessage('Marked as paid successfully'); 
}); 
},
                      err => {
 this.showMessage( err.error.message || err.error || err.message) ; 
}
                    );
                  }
                });
              },
              (rows: VoucherOrder[]) => {
                 const netPendingRows = rows.filter(x => x.voucherOrderStatus !== VoucherOrderStatus.Pending);
                  return  netPendingRows.length > 0;
              },
        ),
        new AppMatCustomAction('euro_symbol', 'Mark as Paid', false, (row: VoucherOrder) => {
                const dialogRef = this.dialog.open(ConfirmDialogComponent, {
                  data: {
                    title: 'Mark as paid',
                    text: 'Are you sure want to mark this voucher order as paid?'
                  },
                  minWidth: 350,
                });
                dialogRef.afterClosed().subscribe(result => {
                  if (result == 'ok') {
                    this.voucherOrdersService.changeStatus( [ row.id ], VoucherOrderStatus.Active ).subscribe(
                      () => {
 this.invoicesService.markAsPaidMany([row.invoiceId]).subscribe(
                        () => {
 this.refreshDataSource(); this.showMessage( 'Marked as paid successfully' ); 
}); 
},
                      err => {
 this.showMessage( err.error.message || err.error || err.message ) ; 
}
                    );
                  }
                });
              },
              (row: VoucherOrder) => row.voucherOrderStatus !== VoucherOrderStatus.Pending, )
      ];
    }
  }

  showMessage( message ) {
    this.snackBar.open( message, null, {
      duration: 5000,
      panelClass: [ 'app-mat-snack-bar' ]
    } );
  }

  refreshDataSource( ) {
    this.dataSource.loadData();
    this.changeDetectorRefs.detectChanges();
    this.table.refreshTable();
  }


  getViewLink = (item: VoucherOrder): string => item.id.toString();

  isAdmin() {
    return this.roleService.hasRoles(['admin']);
  }
}
